import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Every page opens the same way: what this page is, one line on how to read
 * it, and its page-level actions on the right.
 *
 * `hint` is for the reader, not the builder. The old pages leaked internal
 * doc references into operator-facing copy — "not a mean - see Section 5",
 * 'labeled honestly, never as "liked"/"disliked"' — which is a note to
 * whoever wrote the code, not something an operator at 2am needs. Where a
 * caveat genuinely changes how a number should be read, it belongs on the
 * number (see StatTile's `caption`), not in the page subtitle.
 */
export default function PageHeader({ title, hint, back, actions, children }) {
  return (
    <div className="mb-6">
      {back && (
        <Link
          to={back.to}
          className="mb-2 inline-flex items-center gap-1 text-xs font-medium text-ink-secondary hover:text-ink"
        >
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true">
            <path d="M7.5 2.5L4 6l3.5 3.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          {back.label}
        </Link>
      )}
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div className="min-w-0">
          <h1 className="truncate text-xl font-semibold tracking-tight text-ink">{title}</h1>
          {hint && <p className="mt-0.5 text-sm text-ink-secondary">{hint}</p>}
          {children}
        </div>
        {actions && <div className="flex flex-shrink-0 items-center gap-2">{actions}</div>}
      </div>
    </div>
  );
}
